export const UPDATE_PROFIT_BY_SKU_WIDGET = "UPDATE_PROFIT_BY_SKU_WIDGET";